import { render, staticRenderFns } from "./unapprovedMembers.vue?vue&type=template&id=49b3faf4&scoped=true&"
import script from "./unapprovedMembers.vue?vue&type=script&lang=js&"
export * from "./unapprovedMembers.vue?vue&type=script&lang=js&"
import style0 from "./unapprovedMembers.vue?vue&type=style&index=0&id=49b3faf4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b3faf4",
  null
  
)

export default component.exports